<template>
	<section class="ecosizer-intro page-content py-5">
		<div class="container">
			<div class="row justify-content-between intro-content">
				<div class="col-5">
					<header class="page-header">
						<h1 class="color-green mb-4">Ecosizer Utility Calculator</h1>
					</header>
					<p>The Ecosizer Utility Calculator is a free tool for estimating utility costs for central water heating systems based on commercial heat pump water heaters (CHPWHs) in multifamily and commercial buildings. The tool is designed to support the building industry to adopt CHPWHs to improve energy efficiency and reduce greenhouse gas emissions. The Ecosizer Utility Calculator is also intended to provide educational information on CHPWH system utility costs to other stakeholders, for example energy efficiency and building decarbonization advocates, program administrators and implementors, building science researchers, manufacturers, and policy makers.</p>

					<a href="/sizer/docs" class="btn mt-5">
						<span>More Information</span>
						<i class="symbol circle">
							<svg aria-hidden="true">
								<use xlink:href="/static/build/gfx/sprite.svg#symbol-forward"></use>
							</svg>
						</i>
					</a>
				</div>
				<div class="col-6">
					<h6 class="mt-2 mb-3">how to use this tool</h6>
					<ol class="howto">
						<li>Provide input method and values to determine design-day hot water demand by inputting building type and metrics for the building's load based on the type.</li>
						<li>Identify weather conditions (cold water temperature and ambient temperature) by inputting the nearest weather station and cold water temperature.</li>
						<li>Provide the storage and delivery water temperature settings for your system.</li>
						<li>Select the configuration for the temperature maintenance system. </li>
						<li>Select HPWH technology and identify temperature setpoint limitations. Consider potential performance limitations under winter design conditions.</li>
						<li>Revise default values for advanced inputs, if needed.</li>
						<li>Enter utility cost data by uploading a csv or manually inputting base charges, demand charges, and energy charges.</li>
						<li>Enter load shifting paramaters for load shift capable systems.</li>
						<li>Click “Calculate Utility Costs” to obtain minimum sizing results and the Primary Sizing Curve.</li>
					</ol>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'DefaultSizerIntro',
}
</script>
